module.exports = __webpack_public_path__ + "static/media/exc_pum.7b1d21f9.png";